import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { useBooking } from "../context/BookingContext";

const Services = () => {
  const { t } = useLang();
  const { setOpen } = useBooking();

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-36 bg-[#0a0a0a] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-7">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="flex items-center gap-3 mb-6"
            >
              <span className="h-px w-10 bg-gold" />
              <span className="label-eyebrow text-gold">{t.services.eyebrow}</span>
            </motion.div>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="font-display uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tighter"
            >
              {t.services.title}
            </motion.h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="text-white/60 leading-relaxed">{t.services.micro}</p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/5 rounded-sm overflow-hidden">
          {t.services.items.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.55, delay: i * 0.05 }}
              data-testid={`service-card-${i}`}
              className="group bg-[#0d0d0d] hover:bg-[#111111] p-7 md:p-9 transition-all relative overflow-hidden"
            >
              <div className="absolute top-0 left-0 right-0 h-px gold-line opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <div className="label-eyebrow text-white/40 mb-2">
                    0{i + 1}
                  </div>
                  <h3 className="font-display text-2xl md:text-3xl uppercase tracking-tight leading-tight">
                    {item.name}
                  </h3>
                </div>
                <div className="font-display text-3xl md:text-4xl text-gold tracking-tight">
                  {item.price}
                </div>
              </div>
              <button
                onClick={() => setOpen(true)}
                data-testid={`service-book-${i}`}
                className="mt-6 inline-flex items-center gap-1.5 label-eyebrow text-white/60 hover:text-gold transition-colors"
              >
                {t.services.cta}
                <ArrowUpRight className="h-3.5 w-3.5" />
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
